// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { rem } from '../../tokens/conversions';
import { borderRadius } from '../../tokens/spacing';
import { tooltipColors } from './tooltipColors';
export var Tooltip = function(mode) {
    var c = tooltipColors(mode);
    var override = {
        MuiTooltip: {
            styleOverrides: {
                tooltip: function(param) {
                    var ownerState = param.ownerState;
                    // Distance the tooltip box is pushed off the trigger so the arrow sits
                    // flush against it without overlapping. MUI renders the arrow protruding
                    // out of the box toward the trigger by roughly the arrow's own size, so
                    // this margin must be ~arrow size + a small clearance. If the arrow is
                    // allowed to overlap the trigger it intercepts pointer events and blocks
                    // clicks on the edge of the trigger nearest the tooltip. MUI's own
                    // placement margin is a fixed 14px regardless of size, which overlaps the
                    // default arrow (~17px) and floats the small arrow (~8.5px); these
                    // size-aware values replace it. The values are MUI arrow geometry, not
                    // design tokens, so they are not on the spacing scale. Without an arrow
                    // there's no protruding geometry to clear, but the tooltip should still
                    // sit spacing[1] (4px) off the trigger rather than touching it directly.
                    var arrowSize = ownerState.size === 'small' ? rem(10) : rem(18);
                    var arrowClearance = ownerState.arrow ? arrowSize : rem(4);
                    return _object_spread({
                        display: 'flex',
                        alignItems: 'center',
                        gap: rem(12),
                        borderRadius: rem(borderRadius.small),
                        backgroundColor: c.background,
                        border: "".concat(rem(1), " solid ").concat(c.background),
                        color: c.text,
                        padding: "".concat(rem(8), " ").concat(rem(12)),
                        fontSize: rem(14),
                        lineHeight: rem(18),
                        maxWidth: rem(280),
                        // Flex items default to min-width: auto, sized off the widest unbroken
                        // token (URL, hash, long identifier), so it can overflow past maxWidth
                        // instead of wrapping. overflow-wrap/word-wrap: break-word doesn't help —
                        // per spec it's a last-resort line-break rule that isn't factored into
                        // min-content sizing. word-break: break-word is special-cased to behave
                        // like overflow-wrap: anywhere, which IS factored in and actually shrinks
                        // the flex item's automatic minimum width.
                        wordBreak: 'break-word',
                        boxShadow: '0px 10px 30px 0px rgba(0,0,0,0.15)',
                        // Match the specificity of MUI's own placement-margin selectors so
                        // these win and replace the fixed 14px.
                        '.MuiTooltip-popper[data-popper-placement*="top"] &': {
                            marginBottom: arrowClearance
                        },
                        '.MuiTooltip-popper[data-popper-placement*="bottom"] &': {
                            marginTop: arrowClearance
                        },
                        '.MuiTooltip-popper[data-popper-placement*="left"] &': {
                            marginRight: arrowClearance
                        },
                        '.MuiTooltip-popper[data-popper-placement*="right"] &': {
                            marginLeft: arrowClearance
                        }
                    }, ownerState.size === 'small' && {
                        padding: "".concat(rem(4), " ").concat(rem(8)),
                        fontSize: rem(12),
                        lineHeight: rem(16),
                        gap: rem(4)
                    });
                },
                arrow: function(param) {
                    var ownerState = param.ownerState;
                    return _object_spread({
                        fontSize: rem(24),
                        '&::before': {
                            backgroundColor: c.background
                        }
                    }, ownerState.size === 'small' && {
                        fontSize: rem(12)
                    });
                }
            }
        }
    };
    return override;
};

//# sourceMappingURL=Tooltip.js.map